const skills = {
  1: [
    {
      title: "HTML",
      level: 6,
    },
    {
      title: "CSS",
      level: 6,
    },
    {
      title: "JavaScript",
      level: 5,
    },
    {
      title: "TypeScript",
      level: 4,
    },
    {
      title: "React JS",
      level: 5,
    },
    {
      title: "Tailwind CSS",
      level: 5,
    },
    {
      title: "Bootstrap CSS",
      level: 5,
    },
    {
      title: "SASS",
      level: 3,
    },

    {
      title: "Figma",
      level: 4,
    },
  ],
  2: [
    {
      title: "SQL",
      level: 5,
    },
    {
      title: "Node.js",
      level: 4,
    },
    {
      title: "MongoDB",
      level: 3,
    },
    {
      title: "Git",
      level: 4,
    },
    {
      title: "PHP",
      level: 4,
    },
  ],
};

export default skills;
